import React from 'react';
import './Projects.css';
import kavach from '../assets/images/projects/kavach.jpg';
import pingfenceids from '../assets/images/projects/pingfenceids.jpg'
import cnnforskincancer from '../assets/images/projects/cnnforskincancer.png'
import adblocker from '../assets/images/projects/adblocker.jpg'
import esp8266scripts from '../assets/images/projects/esp8266scripts.jpg'
import currencyconverter from '../assets/images/projects/currencyconverter.jpg'
import hashcybersecapp from '../assets/images/projects/hashcybersecurityapp.jpg'
import androidpentesttool from '../assets/images/projects/androidpentestingtool.jpg'
import { Helmet } from 'react-helmet';




function Projects() {
  return <div className='projects-container'>
    <Helmet>
      <title>Aadhaar Koul | Projects</title>
    </Helmet>
    <div className='discount'>
      <a href="/shop"><p>Get upto 75% off on my online Store →</p></a>
    </div>
    <div className='items'>
      <div className='bigttitle' >
        <h1>In The Running</h1>
      </div>
    </div>
    <div className='projects'>
      <div className='project'>
        <div className='project-left'>
          <a href=''>
            <img src={kavach} />
          </a>
        </div>
        <div className='project-right'>
          <h1>Kavach - Cyber Hygiene Tool</h1>
          <p>KAVACH is an AI agent preventing malicious
             activity on networks/browsers. Built with
              Python, JavaScript, and jQuery; frontend 
              in HTML, CSS, Bootstrap; AI components 
              use Python, JavaScript, and neural networks.</p>
          <button className='view-project'><a href='https://github.com/Aadhaar-debug/Cyber_Hygiene_Tool'>View More</a></button>
        </div>
      </div>
      <div className='project'>
        <div className='project-right'>
          <h1>Pingfence - IDS for Home Automation Systems</h1>
          <p>An IDS or an intrusion detection and automation system
             that uses technology such as Honeypot technology,
              and Neural Networks to accurately detect and
               classify intrusions in the network as well 
               as the lodging.</p>
          <button className='view-project'><a href='https://github.com/Aadhaar-debug/SOTA_IDS_Framework_Pingfence'>View More</a></button>
        </div>
        <div className='project-left'>
          <a href=''>
            <img src={pingfenceids} />
          </a>
        </div>
      </div>
      <div className='project'>
        <div className='project-left'>
          <a href=''>
            <img src={cnnforskincancer} />
          </a>
        </div>
        <div className='project-right'>
          <h1>CNN For Skin Cancer Classification</h1>
          <p>A Convolutional Neural Network or a (CNN) model
             for skin cancer detection. Built with Python
              and the library TensorFlow, it analyzes skin images to 
              classify malignancies, aiding early diagnosis
               with deep learning.</p>
          <button className='view-project'><a href='https://github.com/Aadhaar-debug/CNN_For_Skin_cancer'>View More</a></button>
        </div>
      </div>
      <div className='project'>
        <div className='project-right'>
          <h1>Ad Blocker Chrome Extension</h1>
          <p>A Chrome extension that blocks ads using JavaScript, ensuring a seamless video and post-streaming experience. It removes intrusive ads with efficient filtering techniques, enhancing browsing speed and user satisfaction.</p>
          <button className='view-project'><a href='https://github.com/Aadhaar-debug/Browser_extensions'>View More</a></button>
        </div>
        <div className='project-left'>
          <a href=''>
            <img src={adblocker} />
          </a>
        </div>
      </div>
      <div className='project'>
        <div className='project-left'>
          <a href=''>
            <img src={esp8266scripts} />
          </a>
        </div>
        <div className='project-right'>
          <h1>ESP8266 Targetted PC Scripts</h1>
          <p>ESP8266-targeted scripts leveraging network capabilities for deauthentication and internet manipulation. Built for testing and research, it explores wireless security vulnerabilities and network control using ESP8266 modules.</p>
          <button className='view-project'><a href='https://github.com/Aadhaar-debug/SOTA_IDS_Framework_Pingfence'>View More</a></button>
        </div>
      </div>
      <div className='project'>
        <div className='project-right'>
          <h1>Currency Converter Application</h1>
          <p>Built with Java and XML, performs simple 
            math to convert currency rates in real time.
             It provides a user-friendly and an easy to use interface for
              quick and accurate currency conversions against most currencies 
              on the go.</p>
          <button className='view-project'><a href='https://github.com/Aadhaar-debug/Android_Dev_Projects'>View More</a></button>
        </div>
        <div className='project-left'>
          <a href=''>
            <img src={currencyconverter} />
          </a>
        </div>
      </div>
      <div className='project'>
        <div className='project-left'>
          <a href=''>
            <img src={hashcybersecapp} />
          </a>
        </div>
        <div className='project-right'>
          <h1>Hash - Cybersecurity Learning App</h1>
          <p>This cybersecurity app, built with Java and XML, integrates the HTB library to guide beginners in ethical hacking. It provides structured lessons, hands-on exercises, and Linux-free learning for easy onboarding.</p>
          <button className='view-project'><a href='https://github.com/Aadhaar-debug/Cybersecurity_training_app'>View More</a></button>
        </div>
      </div>
      <div className='project'>
        <div className='project-right'>
          <h1>Android Pentesting Tool</h1>
          <p>This Android pentesting tool, built with C# dot net and 
            Python, extracts EXIF data from photos and videos
             to identify potential threats. It helps detect
              malicious activities in the files syatemby analyzing
               metadata for security insights.</p>
          <button className='view-project'><a href='https://github.com/Aadhaar-debug/Linux-Tools'>View More</a></button>
        </div>
        <div className='project-left'>
          <a href=''>
            <img src={androidpentesttool} />
          </a>
        </div>
      </div>
    </div>
  </div>;
}

export default Projects;
